(() => {
  const context = document.querySelector('[data-product-report-context]');
  if (!context) return;

  const title = context.dataset.productTitle || '';
  if (!title) return;

  const compact = (value) =>
    String(value || '')
      .toLowerCase()
      .replace(/sea\s*buck\s*thorn/g, 'seabuckthorn')
      .replace(/rose\s*water/g, 'rosewater')
      .replace(/[^a-z0-9]/g, '');

  const productKey = compact(title);
  const reportTargets = [...document.querySelectorAll('a[href]')].filter((link) => {
    const url = new URL(link.href, window.location.origin);
    return (
      url.pathname.replace(/\/$/, '') === '/pages/test-reports' &&
      /\b(?:see|view)\s+(?:the\s+)?(?:lab\s+)?reports?\b/i.test(link.textContent || '')
    );
  });
  if (!reportTargets.length) return;

  const getProductKey = (reportName) => {
    const coreName = String(reportName || '')
      .trim()
      .replace(
        /\s+(?:pesticide(?:\s+residues?)?|chemical|physical|sugar|melamine|nmr|a2\s+protein)(?:\s+(?:test|report))?$/i,
        '',
      )
      .replace(/\s+(?:test|report)$/i, '');
    return compact(coreName);
  };

  fetch('/pages/test-reports', { credentials: 'same-origin' })
    .then((response) => (response.ok ? response.text() : ''))
    .then((html) => {
      if (!html) return;
      const reportPage = new DOMParser().parseFromString(html, 'text/html');
      const reports = [...reportPage.querySelectorAll('a.report-row[href]')]
        .map((row) => {
          const name = row.querySelector('.report-name')?.textContent?.trim() || '';
          const core = getProductKey(name);
          const type = row.querySelector('.report-type')?.textContent?.trim() || 'Test';
          const date = row.querySelector('.report-date')?.textContent?.trim() || '';
          return { name, core, type, date, href: row.href };
        })
        .filter((report) => report.core && productKey.includes(report.core));

      if (!reports.length) return;

      reportTargets.forEach((originalLink) => {
        const replacement = document.createDocumentFragment();
        reports.forEach((report, index) => {
          if (index > 0) replacement.append(document.createTextNode(' · '));
          const link = document.createElement('a');
          link.href = report.href;
          link.target = '_blank';
          link.rel = 'noopener';
          link.textContent = reports.length === 1
            ? 'See report →'
            : `${report.type}${report.date ? ` · ${report.date}` : ''} →`;
          replacement.append(link);
        });
        originalLink.replaceWith(replacement);
      });
    })
    .catch(() => {
      // If the reports page can't be loaded, leave the existing link intact.
    });
})();
